import { Card, Grid, styled,Button } from "@mui/material";

export const ProjectsPage = styled("div")(({theme}) => ({
  width: "100vw",
  height: "calc(100vh + 150px )",
  // backgroundColor: "#3957D2",
  // backgroundColor: "red",
  maxHeight: "calc(100vh + 150px)",
  maxWidth: "100vw",
  overflow: "hidden",
  // position: 'absolute',
  [theme.breakpoints.down("md")]: {
    height: "fit-content",
    maxHeight: "fit-content",
  },

}));

export const ProjectsScreen = styled("div")(({theme,dark}) => ({
  width: "100vw",
  height: "calc(100vh - 50px)",
  padding: "20px 40px 0px 40px",
  display: "flex",
  flexDirection: "column",


  "& .page-title": {
    fontSize: "3em",
    color: dark?"#1C2028":"#fff",
    fontWeight: 700,
    margin: "20px 0 0 0 ",
  },
  '& .react-reveal:nth-child(2)':{
    width:'100%',
    flex:1
  },
  '& .btn-container':{
    width:'20vw'
  },
  [theme.breakpoints.down("md")]: {
    height: "fit-content",
    maxHeight: "fit-content",
    "& .page-title": {
      fontSize: "2em",
    },
    '& .btn-container':{
      width:'fit-content'
    },
  },
}));


export const ProjectsContainer = styled(Grid)(()=>({
  width:'100%',
  height:'100%',
  marginTop:'20px',
  // backgroundColor:'red',
  // marginLeft:'30px',
  
}))

export const CustomButton = styled(Button)(({dark}) => ({
  width: "fit-content",
  height: "fit-content",
  backgroundColor:  dark?"#1C2028":"#fff",
  padding: "10px 20px",
  color: dark?"#FF3B81":"#3957D2",
  fontWeight: 700,
  marginTop:'50px',
  "&:hover": {
    backgroundColor:  dark?"#1C2028":"#fff",
  },
  '& svg':{
      marginLeft:10
  }
}));